import React, { useState } from 'react';
import { Button } from 'ds/components/button';
import CityIcon from 'assets/svg/house.svg';
import { SmallText, Text } from 'ds/components/typography';
import { CheckboxField } from 'ds/components/input/CheckboxField';
import { Buttons, IconWrapper, Info, InfoWrapper, ItemWrapper, List, ListWrapper, Title, Wrapper } from './styled';
import { NavigateToFn, Route } from 'config/routes';
import { useLocale } from 'locale';
import { noop } from 'lodash';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { CompareListItems } from './types';

export const CompareList: React.FC<{ items: CompareListItems; navigate: NavigateToFn }> = ({ items, navigate }) => {
  const [ activeItems, setAciveItems ] = useState(new Set());
  const { t } = useLocale();
  const isDevice = useScreenBreakpoint() < 3;
  const canSubmit = activeItems.size === 2;

  const handleSelect = (id: string) => {
    const newValue = new Set([ ...activeItems ]);
    if (activeItems.has(id)) {
      newValue.delete(id);
    }
    else {
      if (activeItems.size < 2) {
        newValue.add(id);
      }
    }
    setAciveItems(newValue);
  };

  const handleSubmit = () => {
    const ids = [ ...activeItems ] as string[];
    navigate(Route.InvestorsNeighbourhoodPage, { id: ids[0], compareId: ids[1] });
  };

  return (
    <Wrapper>
      <ListWrapper>
        <Title>{t('investors.compare.marketplace.title')}</Title>
        <List>
          {items.map(item => {
            const isDisabled = activeItems.size >= 2 && !activeItems.has(item.docId);
            return (
              <ItemWrapper data-auto={`investors_compare_marketplace_item_${item.docId}`} isDisabled={isDisabled} key={item.docId} onClick={isDisabled ? noop : () => handleSelect(item.docId)}>
                <InfoWrapper>
                  <IconWrapper>
                    <CityIcon />
                  </IconWrapper>
                  <Info>
                    <Text weight="bold">{item.neighbourhood}, {item.city}</Text>
                    {item.listingCount ? <SmallText>{t('investors.marketplace.compare.listingCount', { count: item.listingCount })}</SmallText> : null}
                  </Info>
                </InfoWrapper>
                <div style={{ flexShrink: 0, marginRight: 'auto', pointerEvents: 'none' }}>
                  <CheckboxField checked={activeItems.has(item.docId)} />
                </div>
              </ItemWrapper>
            );
          })}
        </List>
      </ListWrapper>
      <Buttons>
        <Button
          disabled={!canSubmit}
          fullWidth={isDevice}
          onClick={canSubmit ? handleSubmit : noop}
          size={isDevice ? 'extraLarge' : undefined}
          mode={isDevice ? 'primary' : 'primaryNegative'}
        >
          {t('investors.compare.marketplace.button', { isDevice })}
        </Button>
      </Buttons>
    </Wrapper>
  );
};
